import { createFileRoute } from '@tanstack/react-router'
import RoyaltyErrorsContainer from 'Royalty/containers/RoyaltyErrorsContainer'

export const Route = createFileRoute('/royalty/errorlist')({
    component: RoyaltyErrorsContainer,
})
